export default __webpack_public_path__ + "static/media/resume.1a39ef4d.mp4";